import { useCallback, useEffect, useRef, useState } from "react";

import { getCurrentUser } from "../../../api";
import { logError } from "../../../logging/loggingService";

const resolveRememberPreference = () => {
    let remember = true;
    try {
        if (typeof window !== "undefined") {
            if (window.localStorage?.getItem("authToken")) {
                remember = true;
            } else if (window.sessionStorage?.getItem("authToken")) {
                remember = false;
            }
        }
    } catch (error) {
        /* ignore storage issues */
    }
    return remember;
};

export default function useAccountData({ updateUser }) {
    const isMountedRef = useRef(true);

    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState("");

    const updateAuthUserDetails = useCallback(
        (data) => {
            if (!data) return;
            const remember = resolveRememberPreference();
            updateUser(data, { remember });
        },
        [updateUser]
    );

    const fetchUserInfo = useCallback(async () => {
        setLoading(true);
        setLoadError("");
        try {
            const res = await getCurrentUser();
            const data = res?.data || null;
            if (isMountedRef.current) {
                setUserInfo(data);
                if (data) {
                    updateAuthUserDetails(data);
                }
            }
            return data;
        } catch (err) {
            logError("Accountdaten konnten nicht geladen werden", err, { component: "Account" });
            if (isMountedRef.current) {
                setUserInfo(null);
                setLoadError("Accountdaten konnten nicht geladen werden.");
            }
            return null;
        } finally {
            if (isMountedRef.current) {
                setLoading(false);
            }
        }
    }, [updateAuthUserDetails]);

    const refreshUser = useCallback(async () => {
        const data = await fetchUserInfo();
        if (data) {
            updateAuthUserDetails(data);
        }
        return data;
    }, [fetchUserInfo, updateAuthUserDetails]);

    useEffect(() => {
        isMountedRef.current = true;
        fetchUserInfo();
        return () => {
            isMountedRef.current = false;
        };
    }, [fetchUserInfo]);

    const reload = useCallback(() => {
        fetchUserInfo();
    }, [fetchUserInfo]);

    return {
        userInfo,
        loading,
        loadError,
        fetchUserInfo,
        refreshUser,
        reload,
        updateAuthUserDetails,
    };
}
